import { useState } from "react";
import { List, X } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/common/BrandLogo";

const links = [
  { id: "inicio", label: "Inicio", href: "#inicio" },
  { id: "nosotros", label: "Nosotros", href: "#nosotros" },
  { id: "servicios", label: "Servicios", href: "#servicios" },
  { id: "casos", label: "Casos de éxito", href: "#casos" },
  { id: "contacto", label: "Contacto", href: "#contacto" },
];

export const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const headerLogoClass = isOpen
    ? "h-[100px] w-[248px] sm:h-[104px] sm:w-[262px]"
    : "h-[124px] w-[300px] sm:h-[128px] sm:w-[316px]";

  return (
    <header
      className="sticky top-0 z-50 border-b border-[#DCE6EE] bg-white/90 backdrop-blur-md"
      data-testid="main-navbar"
    >
      <div className="section-container py-1.5">
        <div className="flex items-center justify-between gap-4">
          <a
            href="#inicio"
            className="inline-flex items-center"
            data-testid="navbar-brand-link"
            onClick={() => setIsOpen(false)}
          >
            <BrandLogo className={headerLogoClass} compact={isOpen} imageClassName="object-contain object-left" />
          </a>

          <nav className="hidden items-center gap-8 md:flex" data-testid="navbar-links-wrapper">
            {links.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="corporate-menu-track text-xs uppercase text-[#595959] transition-colors duration-300 hover:text-[#0077B6]"
                data-testid={`navbar-link-${link.id}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          <Button
            asChild
            className="hidden rounded-full bg-[#0077B6] px-5 text-xs uppercase tracking-[0.18em] text-white transition-colors duration-300 hover:bg-[#005F92] md:inline-flex"
            data-testid="navbar-contact-cta-button"
          >
            <a href="#contacto" data-testid="navbar-contact-cta-link">
              Ver contacto
            </a>
          </Button>

          <button
            type="button"
            className="inline-flex items-center justify-center rounded-full border border-[#C9D6E3] bg-white p-2 text-[#595959] md:hidden"
            onClick={() => setIsOpen((prev) => !prev)}
            data-testid="navbar-mobile-menu-toggle"
            aria-label="Abrir menú"
            aria-expanded={isOpen}
          >
            {isOpen ? <X size={18} weight="bold" /> : <List size={18} weight="bold" />}
          </button>
        </div>

        {isOpen && (
          <div className="mt-4 space-y-1 border-t border-[#DCE6EE] pt-4 md:hidden" data-testid="navbar-mobile-menu-panel">
            {links.map((link) => (
              <a
                key={`mobile-${link.href}`}
                href={link.href}
                className="corporate-menu-track block py-2 text-xs uppercase text-[#595959] hover:text-[#0077B6]"
                data-testid={`navbar-mobile-link-${link.id}`}
                onClick={() => setIsOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <Button
              asChild
              className="mt-2 w-full rounded-full bg-[#0077B6] text-xs uppercase tracking-[0.15em] text-white hover:bg-[#005F92]"
              data-testid="navbar-mobile-contact-cta-button"
            >
              <a
                href="#contacto"
                data-testid="navbar-mobile-contact-cta-link"
                onClick={() => setIsOpen(false)}
              >
                Ver contacto
              </a>
            </Button>
          </div>
        )}
      </div>
    </header>
  );
};
